"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WsAiHubAdminMetrics = void 0;
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var office_ui_fabric_react_1 = require("office-ui-fabric-react");
var components_1 = require("../shared/components");
var ai_hub_route_utils_1 = require("../shared/utils/ai-hub-route-utils");
var constants_1 = require("./constants");
var MetricsCategoriesPanel_1 = require("./components/MetricsCategoriesPanel");
var MetricsPropertiesPanel_1 = require("./components/MetricsPropertiesPanel");
var MetricsReviewDrawer_1 = require("./components/MetricsReviewDrawer");
var MetricsSuggestGroupsDrawer_1 = require("./components/MetricsSuggestGroupsDrawer");
var MetricsToolbar_1 = require("./components/MetricsToolbar");
var use_fetch_metrics_schema_1 = require("./hooks/use-fetch-metrics-schema");
var use_metrics_search_1 = require("./hooks/use-metrics-search");
var use_review_queue_1 = require("./hooks/use-review-queue");
var metrics_utils_1 = require("./utils/metrics-utils");
var ai_hub_elements_api_service_1 = require("../shared/services/ai-hub-elements-api.service");
var auth_mocks_1 = require("./auth-mocks");
var demo_auth_context_1 = require("../shared/auth/demo-auth-context");
require("./styles/metrics.scss");
/** Element types exposed in the admin type selector. */
var ELEMENT_TYPE_OPTIONS = [
    { key: 'benefit', text: 'Benefits', icon: 'Trophy' },
    { key: 'budget', text: 'Budget', icon: 'Money' },
    { key: 'data', text: 'Data sources', icon: 'Database' },
    { key: 'integration', text: 'Integrations', icon: 'PlugConnected' },
    { key: 'metric', text: 'Metrics', icon: 'BarChartVertical' },
    { key: 'pain', text: 'Pain points', icon: 'StatusErrorFull' },
    { key: 'persona', text: 'Personas', icon: 'Contact' },
    { key: 'risk', text: 'Risks', icon: 'Warning' },
    { key: 'roadmap', text: 'Roadmap', icon: 'MapDirections' },
    { key: 'tech', text: 'Technologies', icon: 'Devices3' },
];
var DEFAULT_ELEMENT_TYPE = ELEMENT_TYPE_OPTIONS[0].key;
/**
 * WsAiHubAdminMetrics - Business metrics configuration for AI Hub admin.
 *
 * Thin orchestrator that wires together:
 *  - {@link useMetricsDraftSchema}: saved/draft state + change tracking
 *  - {@link useMetricsSearch}: derived search analysis
 *  - Local UI state: selected category, selected properties, inline
 *    category edit, success message, delete confirmation, callout.
 *
 * @returns {JSX.Element} Rendered Metrics admin view.
 */
var WsAiHubAdminMetrics = function () {
    var _a;
    var activeUser = demo_auth_context_1.useDemoAuth().activeUser;
    var history = react_router_dom_1.useHistory();
    var _b = react_1.useState(DEFAULT_ELEMENT_TYPE), elementType = _b[0], setElementType = _b[1];
    var _c = react_1.useState(false), showInactive = _c[0], setShowInactive = _c[1];
    var draft = use_fetch_metrics_schema_1.useFetchMetricsSchema(elementType, { includeInactive: showInactive });
    var draftSchema = draft.draftSchema, savedSchema = draft.savedSchema, hasChanges = draft.hasChanges, updateDraft = draft.updateDraft, discardChanges = draft.discardChanges, isCategoryChanged = draft.isCategoryChanged, isPropertyChanged = draft.isPropertyChanged, findCategory = draft.findCategory, isLoading = draft.isLoading, isSaving = draft.isSaving, apiError = draft.apiError, saveChangesAsync = draft.saveChangesAsync;
    var _d = react_1.useState(null), selectedCategoryId = _d[0], setSelectedCategoryId = _d[1];
    var _e = react_1.useState([]), selectedPropertyIds = _e[0], setSelectedPropertyIds = _e[1];
    var _f = react_1.useState(null), categoryEdit = _f[0], setCategoryEdit = _f[1];
    var _g = react_1.useState(''), successMessage = _g[0], setSuccessMessage = _g[1];
    var _h = react_1.useState(null), openUseCasesPropertyId = _h[0], setOpenUseCasesPropertyId = _h[1];
    var _j = react_1.useState(false), isDeleteDialogOpen = _j[0], setIsDeleteDialogOpen = _j[1];
    var _k = react_1.useState(''), searchText = _k[0], setSearchText = _k[1];
    var _l = react_1.useState(false), isReviewDrawerOpen = _l[0], setIsReviewDrawerOpen = _l[1];
    var _m = react_1.useState(false), isSuggestDrawerOpen = _m[0], setIsSuggestDrawerOpen = _m[1];
    var _o = react_1.useState([]), suggestions = _o[0], setSuggestions = _o[1];
    var _p = react_1.useState(false), isSuggesting = _p[0], setIsSuggesting = _p[1];
    var _q = react_1.useState(null), suggestError = _q[0], setSuggestError = _q[1];
    var _r = react_1.useState({}), groupOwnerSelectionsByCategoryId = _r[0], setGroupOwnerSelectionsByCategoryId = _r[1];
    var allowedElementTypeKeys = react_1.useMemo(function () {
        var role = activeUser.role;
        if (role === 'admin') {
            return new Set(ELEMENT_TYPE_OPTIONS.map(function (option) { return option.key; }));
        }
        var keys = new Set();
        activeUser.permissions.forEach(function (scope) {
            var categoryKey = scope.split('.')[0];
            if (!ELEMENT_TYPE_OPTIONS.some(function (option) { return option.key === categoryKey; })) {
                return;
            }
            if (scope === categoryKey + ".*" || scope.startsWith(categoryKey + ".")) {
                keys.add(categoryKey);
            }
        });
        return keys;
    }, [activeUser.permissions, activeUser.role]);
    var visibleElementTypeOptions = react_1.useMemo(function () { return ELEMENT_TYPE_OPTIONS.filter(function (option) { return allowedElementTypeKeys.has(option.key); }); }, [allowedElementTypeKeys]);
    react_1.useEffect(function () {
        var _a;
        if (visibleElementTypeOptions.some(function (option) { return option.key === elementType; })) {
            return;
        }
        var nextElementType = (_a = visibleElementTypeOptions[0]) === null || _a === void 0 ? void 0 : _a.key;
        if (!nextElementType) {
            return;
        }
        setElementType(nextElementType);
        setSelectedCategoryId(null);
        setSelectedPropertyIds([]);
        setSuccessMessage('');
    }, [elementType, visibleElementTypeOptions]);
    var reviewQueue = use_review_queue_1.useReviewQueue(elementType);
    // Realign the selected category whenever the schema reloads (initial
    // fetch, type change, or post-save refresh) so the right-hand panel
    // is never blank.
    react_1.useEffect(function () {
        if (selectedCategoryId && draftSchema.some(function (category) { return category.id === selectedCategoryId; })) {
            return;
        }
        setSelectedCategoryId(draftSchema[0] ? draftSchema[0].id : null);
        setSelectedPropertyIds([]);
    }, [draftSchema, selectedCategoryId]);
    var selectedCategory = react_1.useMemo(function () { return findCategory(selectedCategoryId); }, [findCategory, selectedCategoryId]);
    var search = use_metrics_search_1.useMetricsSearch(draftSchema, searchText);
    var visibleSelectedProperties = react_1.useMemo(function () {
        var searchedProperties = search.visiblePropertiesFor(selectedCategory);
        if (activeUser.role !== 'owner') {
            return searchedProperties;
        }
        return searchedProperties.filter(function (property) {
            return auth_mocks_1.getOwnersForMetricsProperty(property.id).some(function (owner) { return owner.id === activeUser.id; });
        });
    }, [activeUser.id, activeUser.role, search, selectedCategory]);
    var allVisiblePropertyIds = react_1.useMemo(function () { return visibleSelectedProperties.map(function (property) { return property.id; }); }, [visibleSelectedProperties]);
    var visibleSelectedCount = react_1.useMemo(function () {
        return selectedPropertyIds.filter(function (propertyId) { return allVisiblePropertyIds.indexOf(propertyId) >= 0; })
            .length;
    }, [selectedPropertyIds, allVisiblePropertyIds]);
    var moveToOptions = react_1.useMemo(function () {
        return draftSchema.map(function (category) { return ({
            key: category.id,
            text: category.name + " (" + category.properties.length + ")",
            disabled: category.id === selectedCategoryId,
        }); });
    }, [draftSchema, selectedCategoryId]);
    var groupOwnerOptions = react_1.useMemo(function () {
        return auth_mocks_1.getGroupOwnerCandidates().map(function (user) { return ({
            key: user.id,
            text: user.displayName,
        }); });
    }, []);
    var selectedGroupOwnerIds = react_1.useMemo(function () {
        if (!selectedCategory) {
            return [];
        }
        var selectedByUser = groupOwnerSelectionsByCategoryId[selectedCategory.id];
        if (selectedByUser) {
            return selectedByUser;
        }
        return auth_mocks_1.getGroupOwnersForMetricsCategory(selectedCategory.id).map(function (user) { return user.id; });
    }, [groupOwnerSelectionsByCategoryId, selectedCategory]);
    var canEditGroupOwners = activeUser.role === 'admin';
    // --- Handlers --------------------------------------------------------
    var dismissSuccessOnEdit = function () {
        if (successMessage) {
            setSuccessMessage('');
        }
    };
    var handleSelectCategory = function (category) {
        setSelectedCategoryId(category.id);
        setSelectedPropertyIds([]);
        if (categoryEdit && categoryEdit.mode === 'edit' && categoryEdit.categoryId !== category.id) {
            setCategoryEdit(null);
        }
    };
    var handleStartAddCategory = function () {
        setCategoryEdit({ mode: 'add', categoryId: null, draftName: '' });
    };
    var handleStartEditCategory = function () {
        if (!selectedCategory) {
            return;
        }
        setCategoryEdit({
            mode: 'edit',
            categoryId: selectedCategory.id,
            draftName: selectedCategory.name,
        });
    };
    var handleConfirmCategoryEdit = function () {
        if (!categoryEdit) {
            return;
        }
        var nextName = categoryEdit.draftName.trim();
        if (!nextName) {
            return;
        }
        if (categoryEdit.mode === 'add') {
            var newId = metrics_utils_1.generateMetricsCategoryId(draftSchema);
            var newCategory_1 = {
                id: newId,
                name: nextName,
                kind: 'predefined',
                properties: [],
            };
            updateDraft(function (next) { return __spreadArrays([newCategory_1], next); });
            setSelectedCategoryId(newId);
            setSelectedPropertyIds([]);
        }
        else if (categoryEdit.categoryId) {
            var categoryId_1 = categoryEdit.categoryId;
            // Once an AI-generated group has been edited by an admin, treat it
            // as a curated/predefined group so the badge no longer claims the
            // name was machine-generated.
            updateDraft(function (next) {
                return next.map(function (category) {
                    return category.id === categoryId_1
                        ? __assign(__assign({}, category), { name: nextName, kind: 'predefined' }) : category;
                });
            });
        }
        setCategoryEdit(null);
        dismissSuccessOnEdit();
    };
    var handleDiscardCategoryEdit = function () {
        setCategoryEdit(null);
    };
    var handleConfirmDeleteCategory = function () {
        if (!selectedCategoryId) {
            setIsDeleteDialogOpen(false);
            return;
        }
        var deletedId = selectedCategoryId;
        updateDraft(function (next) { return next.filter(function (category) { return category.id !== deletedId; }); });
        setSelectedPropertyIds([]);
        setCategoryEdit(null);
        var remaining = draftSchema.filter(function (category) { return category.id !== deletedId; });
        setSelectedCategoryId(remaining[0] ? remaining[0].id : null);
        setIsDeleteDialogOpen(false);
        dismissSuccessOnEdit();
    };
    var handleTogglePropertySelection = function (propertyId) {
        setSelectedPropertyIds(function (current) {
            return current.indexOf(propertyId) >= 0
                ? current.filter(function (id) { return id !== propertyId; })
                : current.concat(propertyId);
        });
    };
    var handleToggleSelectAll = function (nextChecked) {
        if (nextChecked) {
            setSelectedPropertyIds(allVisiblePropertyIds.slice());
        }
        else {
            setSelectedPropertyIds(function (current) {
                return current.filter(function (propertyId) { return allVisiblePropertyIds.indexOf(propertyId) < 0; });
            });
        }
    };
    var handleMoveSelected = function (targetCategoryId) {
        if (!selectedCategoryId || selectedPropertyIds.length === 0) {
            return;
        }
        var sourceCategoryId = selectedCategoryId;
        updateDraft(function (next) {
            var source = next.find(function (c) { return c.id === sourceCategoryId; });
            var target = next.find(function (c) { return c.id === targetCategoryId; });
            if (!source || !target) {
                return next;
            }
            var moved = source.properties.filter(function (property) { return selectedPropertyIds.indexOf(property.id) >= 0; });
            source.properties = source.properties.filter(function (property) { return selectedPropertyIds.indexOf(property.id) < 0; });
            target.properties = target.properties.concat(moved);
            return next;
        });
        setSelectedPropertyIds([]);
        dismissSuccessOnEdit();
    };
    var handleSaveChanges = function () {
        void saveChangesAsync()
            .then(function () {
            setCategoryEdit(null);
            setSuccessMessage('Metric groups saved successfully.');
        })
            .catch(function () {
            // Error already surfaced via the apiError MessageBar.
        });
    };
    var handleDiscardChanges = function () {
        discardChanges();
        setCategoryEdit(null);
        setSelectedPropertyIds([]);
        setSuccessMessage('');
        if (!savedSchema.some(function (category) { return category.id === selectedCategoryId; })) {
            setSelectedCategoryId(savedSchema[0] ? savedSchema[0].id : null);
        }
    };
    var handleOpenUseCase = function (useCaseId) {
        history.push(ai_hub_route_utils_1.buildAiHubUseCaseDetailsPath(useCaseId));
    };
    var handleToggleUseCases = function (propertyId) {
        setOpenUseCasesPropertyId(function (current) { return (current === propertyId ? null : propertyId); });
    };
    var handleSuggestGroups = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsSuggestDrawerOpen(true);
                    setIsSuggesting(true);
                    setSuggestError(null);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, ai_hub_elements_api_service_1.suggestElementGroups(elementType)];
                case 2:
                    response = _a.sent();
                    setSuggestions(Array.isArray(response === null || response === void 0 ? void 0 : response.suggestions) ? response.suggestions : []);
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    setSuggestError(error_1 instanceof Error ? error_1.message : String(error_1));
                    setSuggestions([]);
                    return [3 /*break*/, 5];
                case 4:
                    setIsSuggesting(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleApplySuggestion = function (input) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, ai_hub_elements_api_service_1.applyElementGroupSuggestion({
                        type: elementType,
                        groupName: input.groupName,
                        description: input.description,
                        memberElementIds: input.memberElementIds,
                    })];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, draft.refresh()];
                case 2:
                    _a.sent();
                    setSuccessMessage("Group \u201C" + input.groupName + "\u201D created and " + input.memberElementIds.length + " elements linked.");
                    return [2 /*return*/];
            }
        });
    }); };
    // --- Derived UI state ------------------------------------------------
    var isEditingCategory = categoryEdit !== null;
    var canEditCategory = !!selectedCategory && !isEditingCategory;
    var canDeleteCategory = !!selectedCategory && !isEditingCategory && selectedCategory.properties.length === 0;
    var selectAllChecked = allVisiblePropertyIds.length > 0 && visibleSelectedCount === allVisiblePropertyIds.length;
    var selectAllIndeterminate = visibleSelectedCount > 0 && visibleSelectedCount < allVisiblePropertyIds.length;
    var deleteTooltip = !selectedCategory
        ? 'Select an empty metric group to delete it'
        : selectedCategory.properties.length > 0
            ? 'Only metric groups without any signals can be deleted. Move or remove the signals first.'
            : 'Delete selected metric group';
    var matchedSignalCountFor = function (categoryId) {
        if (!search.isSearching) {
            return 0;
        }
        var entry = search.analysisByCategory[categoryId];
        return entry ? entry.matchingProperties.length : 0;
    };
    return (react_1.default.createElement("div", { className: "ws-ai-hub-admin-metrics" },
        react_1.default.createElement("h1", null,
            "Metrics - user ",
            activeUser.displayName,
            " (role: ",
            activeUser.role,
            ")"),
        react_1.default.createElement(office_ui_fabric_react_1.Pivot, { className: "ws-metrics-type-pivot", selectedKey: elementType, onLinkClick: function (item) {
                if (!item || !item.props.itemKey || item.props.itemKey === elementType) {
                    return;
                }
                if (isLoading || isSaving) {
                    return;
                }
                if (hasChanges) {
                    discardChanges();
                }
                setElementType(item.props.itemKey);
                setSelectedCategoryId(null);
                setSelectedPropertyIds([]);
                setSuccessMessage('');
            }, headersOnly: true }, visibleElementTypeOptions.map(function (option) { return (react_1.default.createElement(office_ui_fabric_react_1.PivotItem, { key: option.key, itemKey: option.key, headerText: option.text, itemIcon: option.icon })); })),
        react_1.default.createElement("div", { className: "ws-metrics-category-toolbar-row" },
            react_1.default.createElement("div", { className: "ws-metrics-category-toolbar-row-actions" },
                react_1.default.createElement(MetricsToolbar_1.MetricsToolbar, { edit: categoryEdit, canEdit: canEditCategory, canDelete: canDeleteCategory, deleteTooltip: deleteTooltip, onStartAdd: handleStartAddCategory, onStartEdit: handleStartEditCategory, onRequestDelete: function () { return setIsDeleteDialogOpen(true); }, onChangeDraftName: function (nextValue) {
                        return setCategoryEdit(function (current) {
                            return current ? __assign(__assign({}, current), { draftName: nextValue }) : current;
                        });
                    }, onConfirmEdit: handleConfirmCategoryEdit, onDiscardEdit: handleDiscardCategoryEdit }),
                !categoryEdit && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("span", { className: "ws-metrics-toolbar-separator", "aria-hidden": "true", role: "separator" }),
                    react_1.default.createElement(office_ui_fabric_react_1.DefaultButton, { iconProps: { iconName: 'Lightbulb' }, text: "Suggest Groups", title: "Cluster ungrouped " + elementType + " elements and propose AI-named groups", ariaLabel: "Suggest groups", className: "ws-admin-button-hover-accent", onClick: handleSuggestGroups, disabled: isLoading || isSaving }),
                    react_1.default.createElement("span", { className: "ws-metrics-toolbar-separator", "aria-hidden": "true", role: "separator" }),
                    react_1.default.createElement(office_ui_fabric_react_1.PrimaryButton, { iconProps: { iconName: 'Save' }, text: "Save Changes", className: "ws-admin-button-filled-primary", disabled: !hasChanges || isSaving, onClick: handleSaveChanges }),
                    react_1.default.createElement(office_ui_fabric_react_1.IconButton, { iconProps: { iconName: 'Undo' }, title: "Discard Changes", ariaLabel: "Discard Changes", className: "ws-admin-button-neutral-icon", disabled: !hasChanges || isSaving, onClick: handleDiscardChanges }))),
                (isLoading || isSaving || reviewQueue.isLoading) && (react_1.default.createElement(office_ui_fabric_react_1.Spinner, { size: office_ui_fabric_react_1.SpinnerSize.small, label: isSaving ? 'Saving…' : isLoading ? 'Loading groups…' : 'Checking review queue…', labelPosition: "right", styles: {
                        root: { marginLeft: 12 },
                        label: { fontSize: 12, color: '#605e5c' },
                    } }))),
            react_1.default.createElement("div", { className: "ws-metrics-category-toolbar-row-search" },
                react_1.default.createElement(office_ui_fabric_react_1.SearchBox, { placeholder: "Search groups and elements", value: searchText, disableAnimation: true, onChange: function (_, nextValue) { return setSearchText(nextValue || ''); }, onClear: function () { return setSearchText(''); }, styles: { root: { minWidth: 240, maxWidth: 320 } } }))),
        react_1.default.createElement("div", { className: "ws-metrics-action-container" },
            react_1.default.createElement("div", { className: "ws-metrics-category-toolbar-group-owner" },
                react_1.default.createElement("span", { className: "ws-metrics-category-toolbar-group-owner-label" }, "Group owners"),
                react_1.default.createElement(office_ui_fabric_react_1.Dropdown, { ariaLabel: "Group owners", className: "ws-metrics-category-toolbar-group-owner-dropdown", multiSelect: true, selectedKeys: selectedGroupOwnerIds, options: groupOwnerOptions, disabled: !selectedCategory || !canEditGroupOwners, placeholder: "Select group owners", onChange: function (_event, option) {
                        if (!option || !selectedCategory) {
                            return;
                        }
                        var ownerId = option.key;
                        setGroupOwnerSelectionsByCategoryId(function (current) {
                            var _a;
                            var currentSelected = current[selectedCategory.id] || selectedGroupOwnerIds;
                            var nextSelected = option.selected
                                ? currentSelected.concat(ownerId)
                                : currentSelected.filter(function (existingId) { return existingId !== ownerId; });
                            return __assign(__assign({}, current), (_a = {}, _a[selectedCategory.id] = nextSelected, _a));
                        });
                    } })),
            react_1.default.createElement(office_ui_fabric_react_1.Toggle, { label: "Show inactive", inlineLabel: true, checked: showInactive, disabled: isLoading || isSaving, onChange: function (_event, checked) { return setShowInactive(!!checked); }, styles: { root: { marginTop: 2 }, label: { fontSize: 12 } } })),
        apiError && react_1.default.createElement(office_ui_fabric_react_1.MessageBar, { messageBarType: office_ui_fabric_react_1.MessageBarType.error }, apiError),
        reviewQueue.items.length > 0 && (react_1.default.createElement("div", { className: "ws-metrics-review-banner-slot" },
            react_1.default.createElement(office_ui_fabric_react_1.MessageBar, { messageBarType: office_ui_fabric_react_1.MessageBarType.warning, className: "ws-metrics-review-banner", isMultiline: false, truncated: false, actions: react_1.default.createElement(office_ui_fabric_react_1.DefaultButton, { text: "Open review queue", iconProps: { iconName: 'OpenPane' }, onClick: function () { return setIsReviewDrawerOpen(true); }, className: "ws-metrics-review-banner-cta" }) },
                react_1.default.createElement("span", { className: "ws-metrics-review-banner-text" },
                    react_1.default.createElement("strong", null, reviewQueue.items.length),
                    "\u00A0extracted",
                    ' ',
                    ((_a = ELEMENT_TYPE_OPTIONS.find(function (o) { return o.key === elementType; })) === null || _a === void 0 ? void 0 : _a.text.toLowerCase()) ||
                        'elements',
                    ' ',
                    "waiting for confirmation.")))),
        successMessage && (react_1.default.createElement(office_ui_fabric_react_1.MessageBar, { messageBarType: office_ui_fabric_react_1.MessageBarType.success, onDismiss: function () { return setSuccessMessage(''); }, dismissButtonAriaLabel: "Close" }, successMessage)),
        react_1.default.createElement("div", { className: "ws-metrics-body" },
            react_1.default.createElement(MetricsCategoriesPanel_1.MetricsCategoriesPanel, { draftSchema: draftSchema, visibleCategories: search.visibleCategories, hasResults: search.hasResults, searchText: searchText, searchMatcher: search.searchMatcher, selectedCategoryId: selectedCategoryId, isCategoryChanged: isCategoryChanged, matchedSignalCountFor: matchedSignalCountFor, onSelectCategory: handleSelectCategory }),
            react_1.default.createElement(MetricsPropertiesPanel_1.MetricsPropertiesPanel, { elementType: elementType, selectedCategory: selectedCategory, visibleProperties: visibleSelectedProperties, isSearching: search.isSearching, searchText: searchText, searchMatcher: search.searchMatcher, selectedPropertyIds: selectedPropertyIds, selectAllChecked: selectAllChecked, selectAllIndeterminate: selectAllIndeterminate, visibleSelectedCount: visibleSelectedCount, moveToOptions: moveToOptions, openUseCasesPropertyId: openUseCasesPropertyId, isPropertyChanged: isPropertyChanged, onToggleSelectAll: handleToggleSelectAll, onMoveSelected: handleMoveSelected, onTogglePropertySelection: handleTogglePropertySelection, onToggleUseCases: handleToggleUseCases, onDismissUseCases: function () { return setOpenUseCasesPropertyId(null); }, onOpenUseCase: handleOpenUseCase })),
        react_1.default.createElement(components_1.ConfirmDialog, { hidden: !isDeleteDialogOpen, variant: "error", title: "Delete metric group", message: selectedCategory
                ? "Are you sure you want to delete \"" + (selectedCategory.name || constants_1.METRICS_UNTITLED_GROUP) + "\"? This change will apply once you click Save Changes."
                : 'Are you sure you want to delete this metric group?', confirmText: "Delete", cancelText: "Cancel", onConfirm: handleConfirmDeleteCategory, onCancel: function () { return setIsDeleteDialogOpen(false); } }),
        react_1.default.createElement(MetricsReviewDrawer_1.MetricsReviewDrawer, { isOpen: isReviewDrawerOpen, onDismiss: function () { return setIsReviewDrawerOpen(false); }, items: reviewQueue.items, isLoading: reviewQueue.isLoading, error: reviewQueue.error, onApprove: function (id, notes) { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, reviewQueue.approve(id, notes)];
                        case 1:
                            _a.sent();
                            return [4 /*yield*/, draft.refresh()];
                        case 2:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            }); }, onReject: function (id, notes) { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, reviewQueue.reject(id, notes)];
                        case 1:
                            _a.sent();
                            return [4 /*yield*/, draft.refresh()];
                        case 2:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            }); }, onEdit: function (id, body) { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, reviewQueue.edit(id, body)];
                        case 1:
                            _a.sent();
                            return [4 /*yield*/, draft.refresh()];
                        case 2:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            }); } }),
        react_1.default.createElement(MetricsSuggestGroupsDrawer_1.MetricsSuggestGroupsDrawer, { isOpen: isSuggestDrawerOpen, onDismiss: function () { return setIsSuggestDrawerOpen(false); }, elementType: elementType, suggestions: suggestions, isLoading: isSuggesting, error: suggestError, onApply: handleApplySuggestion })));
};
exports.WsAiHubAdminMetrics = WsAiHubAdminMetrics;
